import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { SnackbarProvider } from 'notistack'
import { useAuthStore } from '@/auth/authStore';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'

function handleSessionExpired() {
  const auth = useAuthStore.getState();
  if (auth?.setUnauthenticated) {
    auth.setUnauthenticated();
  }
  window.location.replace('/login');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      onError: (error) => {
        if (error && typeof error === 'object' && 'status' in error && (error as any).status === 401) {
          handleSessionExpired();
        }
      },
    },
    mutations: {
      retry: false,
      onError: (error) => {
        if (error && typeof error === 'object' && 'status' in error && (error as any).status === 401) {
          handleSessionExpired();
        }
      },
    },
  },
});
const theme = createTheme({ 
  typography: {
    fontSize: 12, // base size (px)
  },
  cssVariables: {
    nativeColor: true,
  },
  palette: {
    primary: {
      main: 'rgb(var(--primary))',
      light: 'rgb(var(--light-primary))',
      dark: 'rgb(var(--dark-primary))',
    },
  },
  zIndex: {
    mobileStepper: 25, // 1000
    fab: 30, //1050
    speedDial: 30, //1050
    appBar: 45, //1100
    drawer: 40, //1200
    modal: 50, //1300
    snackbar: 60, //1400
    tooltip: 70, //1500
  },
 });

export function mountIsland(elId: string, IslandComponent: React.FC) {
  const el = document.getElementById(elId);
  if (!el) return;

  createRoot(el).render(
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
          <SnackbarProvider
            maxSnack={5}
            autoHideDuration={4000}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            preventDuplicate
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <IslandComponent />
            </LocalizationProvider>
          </SnackbarProvider>
        </ThemeProvider>
    </QueryClientProvider>
  );
}
